import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import { getRedeemPoints, generateGiftCard } from "./_request";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SimpleBackdrop from "components/MDLoader_Backdrop";
// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";
//import { RESTAURANT_LEVEL, CASHBACK_STATUS, POINTS_EARNED } from "../../core/constant";
import PaginationControlled from "../../../core/utils/_pagination";

// Data
import additionalPointsHistoryData from "../data/additionalPointsHistoryData";
import { useAuth } from "context";
import AdditionalPointsMobile from "./AdditionalPointsMobile";

function AdditionalPoints() {
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const { miniSidenav } = useAuth();
  const [additionalPointsForMobile, setAdditionalPointsForMobile] = useState([]);
  const { columns, rows } = additionalPointsHistoryData(setLoader, setAdditionalPointsForMobile);

  return (
    <>
      <MDBox pt={2}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {miniSidenav && rows.length > 0 && (
                <MDBox
                  mt={2}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <PaginationControlled page={page} setPage={setPage} totalPage={totalPage} />
                </MDBox>
              )}
              <MDBox pt={1}>
                {!loader ? (
                  miniSidenav ? (
                    <AdditionalPointsMobile additionalPointsForMobile={additionalPointsForMobile} />
                  ) : (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  )
                ) : (
                  <SimpleBackdrop />
                )}
              </MDBox>
              {!miniSidenav && rows.length > 0 && (
                <MDBox p={2} mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                  <PaginationControlled page={page} setPage={setPage} totalPage={totalPage} />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </>
  );
}

export default AdditionalPoints;
